const BND_TYPE = 'combos';
const FBT_TYPE = 'bundles';

const productTransformer = (payload, shopifyProducts = [], currencyCode = 'EUR') => {
  // check format of payload
  const product = payload.product ? payload.product : payload;
  const shopifyProduct = shopifyProducts.find((p) => p?.handle === product.handle);
  const availableVariants = product.allowedVariants.length > 0 ? product.allowedVariants : product.variants;

  return {
    id: product.id,
    handle: product.handle,
    title: product.title,
    bodyHtml: product.bodyHtml,
    productCardUsp: shopifyProduct?._productCardUsp?.value ?? null,
    productType: product.productType,
    images: [
      product.featuredImage ? { src: product.featuredImage.src } : null,
      ...product.images.map((image) => {
        return { src: image.src };
      }),
    ].filter((image) => image !== null),
    variants: availableVariants
      .sort((a, b) => a.position - b.position)
      .map((variant) => {
        const shopifyVariant = shopifyProduct?.variants?.edges.find((v) => v.node.id.includes(variant.id));

        return {
          id: variant.id,
          title: variant.title,
          price: { amount: variant.price, currencyCode },
          sku: variant.sku,
          image: variant.image ? variant.image.src : null,

          // enrich with shopify data
          available: shopifyVariant?.node.available ?? false,
          compareAtPrice: shopifyVariant?.node.compareAtPrice,
          unitPrice: shopifyVariant?.node.unitPrice,
          unitPriceMeasurement: shopifyVariant?.node.unitPriceMeasurement,
        };
      }),
    shopifyProduct,
  };
};

export { productTransformer, BND_TYPE, FBT_TYPE };
